





























































import { Component, Vue } from 'vue-property-decorator';
import * as _ from 'lodash';
import { DataTableHeader } from 'vuetify';
import { IType } from '@/api/types';
import { getTypes } from '@/api/assgin';
import TypeDialog from '@/components/TypeDialog.vue';
import { getAssignedProducts, getLockProducts, start, unlock } from '../../api/pickup';
import { removeFrontZone } from '../../utils/string';
import { getCurrentDate } from '../../utils/date';

interface IProduct {
  id: string;
  item_name: string;
  item_number: string;
  type: string;
  active: boolean;
}

@Component({
  name: 'PickupFilter',
  components: { TypeDialog },
})
export default class extends Vue {
  private products: IProduct[] = [];

  private selected: string[] = [];

  private date = '';

  private locationCode = '';

  private search = '';

  private typesValue: string[] = [];

  private types: IType[] = [];

  // private productTypes: IType[] = [];

  private headers: DataTableHeader[] = [
    {
      text: 'Number',
      value: 'item_number',
    },
    {
      text: 'Name',
      value: 'item_name',
    },
  ];

  async created() {
    this.date = getCurrentDate();
    this.locationCode = this.$store.getters['user/locationCode'];
    try {
      this.$overlay(true);
      const lockProducts = await getLockProducts(this.date, this.locationCode);
      lockProducts.forEach((product) => {
        this.products.push({
          id: product.id,
          item_name: product.item_name,
          item_number: product.item_number,
          type: product.type,
          active: true,
        });
        this.selected.push(product.item_number);
      });
      const assignedProducts = await getAssignedProducts(this.date, this.locationCode);
      assignedProducts.forEach((product) => {
        this.products.push({
          id: product.id,
          item_name: product.item_name,
          item_number: product.item_number,
          type: product.type,
          active: false,
        });
      });
      this.types = await getTypes(this.date, this.locationCode);
      this.typesValue = this.productTypes.map((product) => product.type_no);
    } finally {
      this.$overlay(false);
    }
  }

  private async startHandle() {
    if (this.selected.length === 0) {
      this.$toast('请选择物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    if (this.selected.length > 4) {
      this.$toast('最多只能选择 4 个物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    await this.start();
    this.$router.push({ name: 'Pickup' });
  }

  private async viewHandle() {
    this.$router.push({ name: 'Pickup' });
  }

  private async start() {
    const addItem: string[] = [];
    const removeItem: string[] = [];

    this.products.forEach((product: IProduct) => {
      if (this.selected.includes(product.item_number)) {
        if (!product.active) {
          addItem.push(product.item_number);
        }
      } else if (product.active) {
        removeItem.push(product.item_number);
      }
    });

    try {
      this.$overlay(true);
      if (removeItem.length > 0) {
        await unlock(this.date, this.locationCode, removeItem);
      }
      if (addItem.length > 0) {
        await start(this.date, this.locationCode, addItem);
      }
    } finally {
      this.$overlay(false);
    }
  }

  private rowClickHandle(product: IProduct) {
    if (this.selected.includes(product.item_number)) {
      const index = this.selected.findIndex((val) => val === product.item_number);
      if (index !== -1) this.selected.splice(index, 1);
    } else {
      this.selected.push(product.item_number);
    }
  }

  private isSelected(product: IProduct) {
    if (this.selected.includes(product.item_number)) {
      return true;
    }
    return false;
  }

  private removeFrontZone(str: string) {
    return removeFrontZone(str);
  }

  private onTypeChange() {
    //
  }

  get height() {
    return window.innerHeight - 250;
  }

  get productTypes(): IType[] {
    const productsGroupByType = _.groupBy(this.products, 'type');
    const productTypeKeys = _.keys(productsGroupByType);
    return this.types.filter((type: IType) => productTypeKeys.includes(type.type_no));
  }

  get productsFilter(): IProduct[] {
    return this.products.filter((product: IProduct) => this.typesValue.includes(product.type));
  }

  get buttonColor(): string {
    if (this.productTypes.length !== this.typesValue.length) {
      return 'primary';
    }
    return '';
  }
}
